module.exports = __webpack_public_path__ + "img/photos/top@2x.jpg";